const faker = require('faker')

export const hasEmptyAttribute = (data) => {
  return Object.values(data).every(x => x === null || x === '')
}

export function searchObjectsByAttribute (arr, attribute, searchTerm) {
  return arr.filter(obj => obj[attribute].toLowerCase().includes(searchTerm.toLowerCase()))
}

export function generateImageUrl (width, height) {
  const imageUrl = `https://lorempixel.com/${width}/${height}/`
  return imageUrl
}

export function randomPartnerCampaigns () {
  const randomNumber = Math.floor(Math.random() * 10) + 1
  // const randomBoolean = Math.random() < 0.5
  const randomBoolean = false
  const array = []

  if (randomBoolean) {
    for (let i = 1; i <= randomNumber; i++) {
      const obj = {
        id: faker.datatype.uuid(),
        slug: faker.datatype.uuid(),
        name: faker.commerce.productName(),
        important: '\\- Oferta válida somente para produtos vendidos e entregues pelo Parceiro;\n**\\',
        eventData: {
          value: (Math.floor(Math.random() * 100) + 1) * 100
        },
        description: 'Este parceiro busca a resolução dos problemas dos clientes com maior eficiência. Domina o mercado há 45 anos',
        howtouse: [
          'Clique em "Acessar" para ser redirecionado ao hotsite do Parceiro;',
          'Os produtos já estarão com o desconto aplicado. '
        ]
      }
      array.push(obj)
    }
  } else {
    array.push({
      id: faker.datatype.uuid(),
      slug: faker.datatype.uuid(),
      name: faker.commerce.productName(),
      important: '\\- Oferta válida somente para produtos vendidos e entregues pelo Parceiro.\\',
      eventData: {
        min_value: Math.floor(Math.random() * 100) + 100,
        max_value: 50000,
        prices_options: [1000, 2000, 5000, 10000, 50000]
      },
      description: 'Este parceiro busca a resolução dos problemas dos clientes com maior eficiência. Domina o mercado há 45 anos',
      howtouse: [
        'Clique em "Acessar" para ser redirecionado ao hotsite do Parceiro;',
        'Os produtos já estarão com o desconto aplicado. '
      ]
    })
  }

  return array
}

export function paginate(
  items,
  pageNumber,
  limitNumber,
) {
  const totalItems = items.length;
  const totalPages = Math.ceil(totalItems / limitNumber);
  const startIndex = (pageNumber - 1) * limitNumber;
  const endIndex = Math.min(startIndex + limitNumber, totalItems);

  const paginatedItems = items.slice(startIndex, endIndex);

  return {
    paginatedItems,
    links: [],
    meta: {
      current_page: pageNumber,
      from: startIndex + 1,
      last_page: totalPages,
      links: [],
      path: "{{base_url}}/statement",
      per_page: limitNumber,
      to: endIndex,
      total: totalItems,
    },
  };
}



// WEBPACK FOOTER //
// ./src/mocks/utils/index.js